import { render, staticRenderFns } from "./teacherTotal1.vue?vue&type=template&id=484de7e2&scoped=true&"
import script from "./teacherTotal1.vue?vue&type=script&lang=js&"
export * from "./teacherTotal1.vue?vue&type=script&lang=js&"
import style0 from "./teacherTotal1.vue?vue&type=style&index=0&id=484de7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484de7e2",
  null
  
)

export default component.exports